import { render, staticRenderFns } from "./parkingAgreement.vue?vue&type=template&id=004987fe&scoped=true"
import script from "./parkingAgreement.vue?vue&type=script&lang=js"
export * from "./parkingAgreement.vue?vue&type=script&lang=js"
import style0 from "./parkingAgreement.vue?vue&type=style&index=0&id=004987fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004987fe",
  null
  
)

export default component.exports